import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch',
      gap: theme.spacing(2),
    },
    iconWrapper: {
      position: 'absolute',
      top: 4,
      right: 'calc(100% + 16px)',
    },
    title: {
      color: COLORS.gray.black,
    },
    description: {
      color: COLORS.neutral.darkGray,
      whiteSpace: 'pre-line',
    },
  }),
  { name: 'BrandVoiceItemEmptyBanner' }
);
